import React from "react";
import { useLayoutEffect, useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useParams } from "react-router-dom";
import { sanityClient, urlFor } from "../client";
import { useGlobalContext } from "../Context";

export default function PlayersName() {
  const { playersname } = useParams();
  const { setNav } = useGlobalContext();
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    setNav(false);
    document.title = `Beyond Limits Football Academy - ${playersname}`;
  }, [setNav, playersname]);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == "${playersname}"][0]{
          _id,
          categories[] ->,
          country,
          date,
          jersey,
          slug{
          current
          },
            mainImage{
              asset->{
                url
              }
            },
          name,
            state,
            surname,
            position
    }
    `
      )
      .then((data) => {
        setLoading(true);
        setPost(data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, [playersname]);

  if (loading) {
    return (
      <section style={{ height: "700px" }}>
        <div className="container">
          <p
            style={{
              fontSize: "5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Loading....
          </p>
        </div>
      </section>
    );
  }

  // console.log(playersname);
  // console.log(post);

  const {
    country,
    date,
    jersey,
    slug,
    mainImage,
    name,
    state,
    surname,
    position,
  } = post;

  return (
    <section className="Players">
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            {mainImage && mainImage.asset && (
              <LazyLoadImage
                alt={slug.current}
                effect="blur"
                src={urlFor(mainImage).url()}
                className="Programs__First--image"
              />
            )}
          </div>
          <div className="col-md-7">
            <div className="Players__Info">
              {surname && (
                <p className="Players__Info--text">
                  surname: <span>{surname}</span>{" "}
                </p>
              )}
              {name && (
                <p className="Players__Info--text">
                  name: <span>{name}</span>{" "}
                </p>
              )}

              {date && (
                <p className="Players__Info--text">
                  date of birth:{" "}
                  <span>
                    {new Date(date).toLocaleDateString("en-US", {
                      dateStyle: "medium",
                    })}{" "}
                  </span>
                </p>
              )}
              {position && (
                <p className="Players__Info--text">
                  position: <span>{position}</span>{" "}
                </p>
              )}
              {jersey && (
                <p className="Players__Info--text">
                  jersey number: <span>{jersey}</span>{" "}
                </p>
              )}
              {state && (
                <p className="Players__Info--text">
                  state of origin: <span>{state}</span>{" "}
                </p>
              )}
              {country && (
                <p className="Players__Info--text">
                  nationality: <span>{country}</span>{" "}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
